import { Skeleton } from "@chakra-ui/react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Stat(_ref) {
  let {
    value,
    children,
    isLoading,
    className
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: `flex flex-col ${className}`,
    children: [/*#__PURE__*/_jsx(Skeleton, {
      isLoaded: !isLoading,
      height: "36px",
      children: /*#__PURE__*/_jsx("h4", {
        className: "text-3xl",
        children: value
      })
    }), /*#__PURE__*/_jsx("span", {
      className: "text-sm md:text-base",
      children: children
    })]
  });
}